import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Block from '../components/Block';
import Heading from '../components/Heading';
import Grid from '@mui/material/Grid/Grid';

import croBrno from '../assets/BrnoCeskyRozhlas.png';
import forbes from '../assets/Forbes.png';
import czechCrunch from '../assets/CzechCrunch.png';
import denik from '../assets/Denik.png';
import ttb from '../assets/ttb.png'
import novinky from '../assets/novinky.svg'
import veda from '../assets/vedaLogo.svg'

interface IState {
}

interface IProps extends WithTranslation {
}


const croBrnoLink = 'https://brno.rozhlas.cz/na-vyvoji-samocistici-folie-spolupracuji-chemici-z-vut-specialni-vrstva-brani-8438148';
const forbesLink = 'https://forbes.cz/viry-a-bakterie-na-displeji-maji-smulu-firma-z-brna-vymyslela-samocistici-folii/';
const czechCrunchLink = 'https://cc.cz/2021/07/dotyk-bez-obav-ceska-antimikrobialni-folie-chce-poskytnout-jistotu-cistoty-pri-pouzivani-dotykovych-displeju/';
const denikLink = 'https://www.denik.cz/pribehy-a-rozhovory/brno-samocistici-folie-podnikani-viry-bakterie-20210503.html';
const ttbLink = 'https://ttb.sk/clanky/lotus-foil-ako-uspesne-spojenie-vedy-a-praxe/'
const novinkyLink = 'https://www.novinky.cz/clanek/veda-skoly-chytry-napad-ceske-vedy-samocistici-folie-na-automaty-ktera-likviduje-viry-40514477'
const vedaLink = 'https://vedavyzkum.cz/inovace-a-transfer/inovace-a-transfer/samocistici-folie-lotus-foil-cesky-patent-chrani-verejne-dotykove-obrazovky'

const croBrnoTitle = 'Český rozhlas Brno';
const forbesTitle = 'Forbes';
const czechCrunchTitle = 'Czech Crunch';
const denikTitle = 'Deník';
const ttbTitle = 'TRANSFER TECHNOLÓGIÍ bulletin'
const novinkyTitle = 'Novinky.cz'
const vedaTitle = 'Věda a výzkum'

class Press extends React.Component<IProps, IState, WithTranslation> {

	constructor(props: IProps){		
		super(props);				
		this.state = {};
	}

	render() {	
		const t = this.props.t;
        const ns = 'main';
        const imgWidth = 250;
        const pressImgs: Array<{
            href: string,
            src: string,
            alt: string
        }> = [
            {
                href:croBrnoLink,
                src:croBrno,
                alt:croBrnoTitle
            },
            {
                href:forbesLink,
                src:forbes,
                alt:forbesTitle
            },
            {
                href:czechCrunchLink,
                src:czechCrunch,
                alt:czechCrunchTitle
            },
            {
                href:denikLink,
                src:denik,
                alt:denikTitle
            },
            {
                href: ttbLink,
                alt: ttbTitle,
                src: ttb
            },
            {
                href: novinkyLink,
                alt: novinkyTitle,
                src: novinky
            },
            {
                href: vedaLink,
                alt: vedaTitle,
                src: veda
            }
        ]

		return <Block fullHeight rounded color='background.paper' sx={{ m: { xs: '30px 30px 100px', md: '150px 0px 240px'} }}>

            <Heading
                sx={{mb: '30px'}}
            >
                {t('written-about-us', {ns})}
            </Heading>
            <Grid container justifyContent="center" sx={{width:"100%"}}>
            <Grid container 
                sx={{ 
                    width: {xs: "auto", lg:"70vw", xl:"55vw"},
                    display: 'flex', justifyContent: 'center',
                    alignItems: 'center',
                    '& > *': { display: 'flex', justifyContent: 'center' }
                }}
                spacing={4}
            >
                {pressImgs.map(img => 
                    <Grid item xs sx={{mt: '30px'}}>
                        <a target='_blank' rel="noreferrer" href={img.href}>
                            <img src={img.src} width={imgWidth} alt={img.alt} />
                        </a>
                    </Grid>
                )}
            </Grid>
            </Grid>
        </Block>;
	}
}

export default withTranslation()(Press);